import { defineComponent, h, useAttrs } from 'vue'
import { VAlert } from 'vuetify/components'
import { hasBooleanishAttr } from './legacyInputProps'

function normalizeBorder(border) {
  if (border === 'left') return 'start'
  if (border === 'right') return 'end'
  return border
}

function normalizeAttrs(attrs) {
  const normalized = { ...attrs }

  if (attrs.variant == null) {
    if (hasBooleanishAttr(attrs.outlined)) {
      normalized.variant = 'outlined'
    } else if (hasBooleanishAttr(attrs.text)) {
      normalized.variant = 'tonal'
    }
  }

  if (attrs.density == null && hasBooleanishAttr(attrs.dense)) {
    normalized.density = 'compact'
  }

  // Vuetify 2's built-in alert-type icons don't match Vuetify 3's icon
  // aliases 1:1 - most notably `type="error"` used the same mdi-alert
  // triangle as `type="warning"` (differentiated only by color), whereas
  // Vuetify 3's `$error` alias resolves to mdi-close-circle. Confirmed by
  // comparing this exact alert against prod. Only override when the caller
  // hasn't picked an icon themselves.
  if (
    attrs.icon == null &&
    (attrs.type === 'error' || attrs.type === 'warning')
  ) {
    normalized.icon = 'mdi-alert'
  }

  normalized.border = normalizeBorder(attrs.border)

  delete normalized.outlined
  delete normalized.text
  delete normalized.dense

  return normalized
}

export default defineComponent({
  name: 'VAlertCompat',
  compatConfig: {
    RENDER_FUNCTION: false,
    COMPONENT_V_MODEL: false,
    INSTANCE_ATTRS_CLASS_STYLE: false
  },
  inheritAttrs: false,

  setup(_, { slots }) {
    const attrs = useAttrs()

    return () => h(VAlert, normalizeAttrs(attrs), slots)
  }
})
